<sh-page theme={{theme_color}}>
    <sh-pane slot='left' behavior="collapse">
        <div class="app-library-div">
            <app-library-browser [assetLibrary]="library" (selectedAsset)="selectAsset($event)"
                [isPersonalBrowser]="true" (folderSelected)="folderSelected($event)" #libBrowser>
            </app-library-browser>
        </div>

        <!-- pane footer -->
        <sh-button slot="footer" color="secondary" label="Reset"></sh-button>
    </sh-pane>
</sh-page>


<!-- <div> -->


<!-- <sh-grid style="padding-top: 0"> -->
<!-- <div columns="2" style="border-right: 1px solid #656464;margin: 0; margin-top: -3%; height:100vh;"
            (click)="httpService.contextmenu ? disableContextMenu() : ''">
            <div style="padding-top: 1em">
                <div class="center-align">
                    <sh-text style="font:var(--header-1);">Personal Browser</sh-text>
                </div>
               
                <div style="padding-bottom: 20px;overflow-y: auto;height:75vh" id="libBrowserDiv">
                    <app-library-browser [assetLibrary]="library" (selectedAsset)="selectAsset($event)"
                        [isPersonalBrowser]="true" (folderSelected)="folderSelected($event)" #libBrowser>
                    </app-library-browser>
                </div>

            </div>
        </div> -->
<!-- <div columns="10" style="text-align: center" class="emptyState cursor-pointer" *ngIf="!asset.relativePath && httpService.folder?.name && httpService.folder?._id"
            routerLink="/val-assets/upload-assets" id="uploadAssetFolder" (click)="httpService.contextmenu ? disableContextMenu() : ''">
            <sh-icon slot="functions" icon="upload-user" style="margin: auto; font-size: 89px"></sh-icon><br>
            <sh-text style="font:var(--super-header);padding-top: 18px">Upload Asset <sh-text *ngIf=" httpService.folder?.name"
                    style="font:var(--super-header);">in {{ httpService.folder?.name }}</sh-text>
            </sh-text>
        </div> -->
<!-- <div columns="6" style="margin: 0; padding-left: 5%;padding-right: 5%;" *ngIf="asset.relativePath"
            (click)="httpService.contextmenu ? disableContextMenu() : ''">
            <div style="padding-top: 0.2em">
                <app-asset-specification *ngIf="asset?.attributes" [assetPath]="asset.relativePath" [asset]="asset"
                    [formats]="formats" [quality]="quality" [textureQuality]="textureQuality"
                    (uneditedAssetEmit)="assignAsset($event)" (selectedAssetFile)="selectedAssetFile($event)"
                    (deleteEmit)="collapseFolder($event)">
                </app-asset-specification>
            </div>
        </div>
        <div columns="4" style="border-left: 1px solid #656464;margin: 0;margin-top: -3%;" *ngIf="asset.relativePath"
            (click)="httpService.contextmenu ? disableContextMenu() : ''">
            <div style="padding: 1em; padding-top: 1.3em">
                <div class="center-align" style="padding-bottom: 1em;">
                    <sh-text style="font:var(--header-1);">Detailed Information</sh-text>
                </div>
                <div *ngIf="loadAsset">
                    <app-asset-information *ngIf="asset.relativePath" [attributes]="asset.attributes"
                        [tags]="asset.tags" [filePath]="assetFilePath"></app-asset-information>
                </div>

            </div>
        </div> -->
<!-- </sh-grid> -->
<!-- </div> -->